<template>
  <div>
    <v-form ref="form">
    <div class="panel-heading d-flex">
      <h4 class="col-md-6 panel-title">Mobile Home Banner (App)</h4>

      <div class="col-md-4">
        <div class="col-md-12 d-flex">

          <v-switch v-model="form.is_datetime" label="Is Counter"></v-switch>
          <v-switch v-model="form.is_active" label="Is Active"></v-switch>
          <v-btn
            color="green"
            style="height: auto;color: white;"
            depressed
            @click="save"
          >
            Save
          </v-btn>
        </div>
      </div>
    </div>

    <div>
      <v-card style="margin: 10px;">
        <v-card-text>
            <div class="row">
              <div class="col-md-4">
                <v-text-field v-model="form.title" label="Title" :rules="titleRules"></v-text-field>
              </div>
              <div class="col-md-4">
                <v-text-field v-model="form.title_ar" label="Title Arabic" :rules="titleArRules"></v-text-field>
              </div>
              <div class="col-md-4">
                <v-text-field v-model="form.title_ku" label="Title Kurdish" :rules="titleKuRules"></v-text-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <label for="description" :style="{ color: descriptionError ? 'red' : 'inherit', opacity: descriptionError ? 1 : 0.8 }" style="font-size: 14px; margin-bottom: -8px">Description</label>
                <textarea v-model="form.description" class="form-control" style="border-bottom: 1px solid blue; font-size: 1.5rem" rows="4"></textarea>
                <div v-if="descriptionError" class="error" style="color: red; font-size: 12px;">{{ descriptionError }}</div>
              </div>
              <div class="col-md-4">
                <label for="description_ar" :style="{ color: descriptionArError ? 'red' : 'inherit', opacity: descriptionArError ? 1 : 0.8 }" style="font-size: 14px; margin-bottom: -8px">Description Arabic</label>
                <textarea v-model="form.description_ar" class="form-control" style="border-bottom: 1px solid blue; font-size: 1.5rem" rows="4"></textarea>
                <div v-if="descriptionArError" class="error" style="color: red; font-size: 12px;">{{ descriptionArError }}</div>
              </div>
              <div class="col-md-4">
                <label for="description_ku" :style="{ color: descriptionKuError ? 'red' : 'inherit', opacity: descriptionKuError ? 1 : 0.8 }" style="font-size: 14px; margin-bottom: -8px">Description Kurdish</label>
                <textarea v-model="form.description_ku" class="form-control" style="border-bottom: 1px solid blue; font-size: 1.5rem" rows="4"></textarea>
                <div v-if="descriptionKuError" class="error" style="color: red; font-size: 12px;">{{ descriptionKuError }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <v-text-field v-model="form.start_date" label="Start Date" type="datetime-local" :rules="startDateRules"></v-text-field>
              </div>
              <div class="col-md-6">
                <v-text-field v-model="form.end_date" label="End Date" type="datetime-local" :rules="endDateRules"></v-text-field>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <v-text-field v-model="form.color" label="Color" type="color" :rules="colorRules"></v-text-field>
              </div>
              <div class="col-md-3">
                <v-text-field v-model="form.color_dark" label="Color Dark" type="color" :rules="colorRules"></v-text-field>
              </div>
              <div class="col-md-3">
                <v-text-field v-model="form.bgcolor" label="Background Color" type="color" :rules="colorRules"></v-text-field>
              </div>
              <div class="col-md-3">
                <v-text-field v-model="form.bgcolor_dark" label="Background Color Dark" type="color" :rules="colorRules"></v-text-field>
              </div>
            </div>
        </v-card-text>
      </v-card>
    </div>
    </v-form>
  </div>
</template>

<script>
import Axios from 'axios'

export default {
  data() {
    return {
      url: 'api/home-banner',
      form: {
        home_banners_id: null,
        title: '',
        title_ar: '',
        title_ku: '',
        description: '',
        description_ar: '',
        description_ku: '',
        start_date: null,
        end_date: null,
        is_active: true,
        color: '#000000',
        bgcolor: '#000000',
        color_dark: '#000000',
        bgcolor_dark: '#000000'
      },
      descriptionError: '',
      descriptionArError: '',
      descriptionKuError: '',
      titleRules: [v => !!v || 'Title is required'],
      titleArRules: [v => !!v || 'Title Arabic is required'],
      titleKuRules: [v => !!v || 'Title Kurdish is required'],
      startDateRules: [v => !!v || 'Start date is required'],
      endDateRules: [
        v => !!v || 'End date is required',
        v => !this.form.start_date || new Date(v) > new Date(this.form.start_date) || 'End date must be after start date'
      ],
      colorRules: [v => /^#[0-9A-F]{6}$/i.test(v) || 'Color must be a valid hex color code']
    }
  },

  mounted() {
    this.getData()
  },

  methods: {
    getData() {
      var token = localStorage.getItem('access_token')

      Axios.get(this.url, { headers: { Authorization: 'Bearer ' + token } }).then(res => {
        const data = res.data.data
        if (data) {
          // Format dates for datetime-local inputs
          if (data.start_date) {
            data.start_date = this.formatDateForInput(data.start_date)
          }
          if (data.end_date) {
            data.end_date = this.formatDateForInput(data.end_date)
          }
          this.form = data
        }
      })
    },

    save() {
      // Reset errors
      this.descriptionError = ''
      this.descriptionArError = ''
      this.descriptionKuError = ''

      let isValid = this.$refs.form.validate()

      if (!this.form.description.trim()) {
        this.descriptionError = 'Description is required'
        isValid = false
      }
      if (!this.form.description_ar.trim()) {
        this.descriptionArError = 'Description Arabic is required'
        isValid = false
      }
      if (!this.form.description_ku.trim()) {
        this.descriptionKuError = 'Description Kurdish is required'
        isValid = false
      }

      if (!isValid) {
        return
      }
      this.update()
    },

    update() {
      var token = localStorage.getItem('access_token')
      Axios.post(this.url, this.form, { headers: { Authorization: 'Bearer ' + token } }).then(res => {
        this.getData()
        swal({
          title: 'Done',
          text: '',
          icon: 'success',
          timer: 500,
          buttons: false
        })
      }).catch(err => {
        console.error('Error response:', err.response)
      })
    },

    formatDateForInput(dateString) {
      if (!dateString) return null
      // Convert ISO string to datetime-local format (YYYY-MM-DDTHH:MM)
      const date = new Date(dateString)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day}T${hours}:${minutes}`
    }
  }
}
</script>

<style>
.switchbutton .input-group__details {
  min-height: 0px !important;
}
.switchbutton {
  margin-top: 10px !important;
}
.error {
  background-color: #fff !important;
  border-color: #fff !important
}
.input-group__details {
  min-height: 0px !important;
}
.switch {
  margin-top: 10px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/homeBanner/homeBanner.vue